module.exports = __webpack_public_path__ + "static/img/Zach-Merrett.35d74c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Zach-Merrett.jpg
// module id = Dc3N
// module chunks = 0